$(".prd-variant-opt").click(function () {
      $(this).siblings().removeClass("active-variant");
      $(this).addClass("active-variant");
    });
      $(".prd-variant-opt:nth-child(1)").addClass("active-variant");

// const radioButtons = $('.prd-radio-btn');
//       radioButtons.on('click', function() {
//       radioButtons.prop('checked', false);
//       $(this).prop('checked', true);
//     });

document.addEventListener("DOMContentLoaded", function () {
  const titleElement = document.getElementById("prd-title");
  if (titleElement) {
    const text = titleElement.textContent.trim();
    const targetWord = "pakket"; // The word to wrap in a <span>
    if (text.includes(targetWord)) {
      titleElement.innerHTML = text.replace(
        targetWord,
        `<span>${targetWord}</span>`
      );
    }
  }
});

 document.addEventListener('DOMContentLoaded', () => {
    // Get the video and button elements
    const video = document.querySelector('video'); // Assuming only one video element
    const playButton = document.getElementById('toggle-play-btn');

    // Add click event listener to the button
    playButton.addEventListener('click', () => {
      video.play(); // Play the video
      playButton.style.display = 'none'; // Hide the button
    });

    // Add click event listener to the video
    video.addEventListener('click', () => {
      if (!video.paused) {
        video.pause(); // Pause the video
        playButton.style.display = 'flex'; // Show the button
      }
    });
  });


$(document).ready(function() {
        $('.cstm-faq-header').on('click', function() {
            $(this).parent('.cstm-faq-item').toggleClass('cstm-active-faq');

            $(this).next('.faq-content').slideToggle();

            $('.cstm-faq-header').not(this).next('.faq-content').slideUp();
            $('.cstm-faq-item').not($(this).parent('.cstm-faq-item')).removeClass('cstm-active-faq');
        });
      $('.cstm-faq-item:first-child .faq-content').slideDown();
  $('.cstm-faq-item:first-child').addClass('cstm-active-faq');
    });

  jQuery('.prd-simple-varaints input.prd-radio-btn').click(function () {
      var d_val = jQuery(this).val();
      $('input.product-variant-id').val(d_val);
    });

 $(document).ready(function() {
        $('.cstm-tabs-btn-wrapper li a').on('click', function(e) {
          e.preventDefault();
          $('.cstm-tabs-btn-wrapper li a').removeClass('sfyn-active-tab-btn');
          $(this).addClass('sfyn-active-tab-btn');
          var target = $(this).data('url');
          $('.prd-variants-inner-main').hide();
          $('.prd-variants-inner-main[data-url-target="' + target + '"]').show();
        });
        $('.cstm-tabs-btn-wrapper li a:last').trigger('click');
      });


$(document).ready(function () {
  $(".prd-variants input").click(function () {
    var option1 = $('input[name="kiesjedeal"]:checked').val();
    var option2 = $('input[name="bezorgschema"]:checked').val();

    if (!option1 || !option2) return;

    option1 = option1.toLowerCase();
    option2 = option2.toLowerCase();

    var variantKey = option1 + option2;

    var variantID = $('input[name="' + variantKey + '"]').val();

    console.log("Variant Key: ", variantKey);
    console.log("Variant ID: ", variantID);

    if (variantID) {
      $('input[name="id"]').val(variantID);
      console.log("Updated ID:", $('input[name="id"]').val());
    }
  });
});

